import { LoadingLayer } from '../../LoadingLayer';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { TopicsList } from '../../../data/TopicsList';
import { saveAbstractRequest } from '../registered-abstracts/RegisteredAbstracts';
import { SideMenuAdmin } from './SideMenuAdmin';
import PropTypes from "prop-types";

export const fetchAbstracts = async (setAbstracts) => {
  try {
    const response = await fetch(
      'https://nt6dwl1xpc.execute-api.us-west-1.amazonaws.com/produccion/admin/abstracts',
      {
        headers: {
          'user-token': localStorage.getItem('id_token'),
        },
      },
    );
    const data = await response.json();
    console.log(data);
    setAbstracts(data.Items);
  } catch (error) {
    console.error('Error:', error);
    return error;
  }
};

export const AdminAbstract = () => {
  const [abstracts, setAbstracts] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');
  const [viewMode, setViewMode] = useState('table'); // 'cards' or 'table'
    const [selectedRevisors, setSelectedRevisors] = useState({}); // { abstractId: [email1, email2] }
    const [savedRevisors, setSavedRevisors] = useState({}); // { abstractId: [email1, email2] } - last saved state from backend
    const [savingRevisors, setSavingRevisors] = useState({}); // { abstractId: true } - currently saving
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const [searchQuery, setSearchQuery] = useState('');
    const [scoreModalAbstract, setScoreModalAbstract] = useState(null);
    const [revisorsEmails, setRevisorsEmails] = useState([]);
    const [acceptType, setAcceptType] = useState({}); // { abstractId: 'oral' | 'poster' | 'rejected' }
    const [acceptingAbstract, setAcceptingAbstract] = useState({}); // { abstractId: true }
    const [certificateType, setCertificateType] = useState({}); // { abstractId: 'oral' | 'poster' | 'attendee' }
    const [sendingCertificate, setSendingCertificate] = useState({}); // { abstractId: true }

  const parseRevisors = (revisor) => {
    if (!revisor) return [];
    if (Array.isArray(revisor)) return revisor.filter(Boolean);
    if (typeof revisor === 'string') {
      return revisor.split(',').map(e => e.trim()).filter(Boolean);
    }
    return [];
  };

  useEffect(() => {
    setIsLoading(true);
    setLoadingMessage('Loading');

    // Fetch revisors from Cognito
    fetch('https://nt6dwl1xpc.execute-api.us-west-1.amazonaws.com/produccion/admin/revisors-list', {
      headers: { 'user-token': localStorage.getItem('id_token') },
    })
      .then(res => res.json())
      .then(data => setRevisorsEmails(data.revisor_emails || []))
      .catch(() => setRevisorsEmails([]));

    fetchAbstracts((items) => {
      setAbstracts(items);
      if (items) {
        const initial = {};
        items.forEach((a) => {
          const parsed = parseRevisors(a.revisor);
          if (parsed.length > 0) {
            initial[a.id] = parsed;
          }
        });
        setSelectedRevisors(initial);
        setSavedRevisors(initial);
      }
    }).then(() => {
      setIsLoading(false);
    });
  }, []);

    const handleAddRevisor = (abstractId, email) => {
        if (!email) return;
        setSelectedRevisors((prev) => {
            const current = prev[abstractId] || [];
            if (current.includes(email) || current.length >= 2) return prev;
            return { ...prev, [abstractId]: [...current, email] };
        });
    };

    const handleRemoveRevisor = (abstractId, email) => {
        setSelectedRevisors((prev) => {
            const current = prev[abstractId] || [];
            return { ...prev, [abstractId]: current.filter(e => e !== email) };
        });
    };

    const updateRevisor = async (abstractId, updated_at, emailsOverride) => {
        const emails = emailsOverride !== undefined ? emailsOverride : (selectedRevisors[abstractId] || []);
        setSavingRevisors((prev) => ({ ...prev, [abstractId]: true }));
        try {
            await fetch('https://nt6dwl1xpc.execute-api.us-west-1.amazonaws.com/produccion/admin/revisor-assign', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'user-token': localStorage.getItem('id_token'),
                },
                body: JSON.stringify({
                    abstract_id: abstractId,
                    updated_at: updated_at,
                    revisor: emails,
                }),
            });
            // Update saved state locally without refreshing all abstracts
            setSavedRevisors((prev) => ({ ...prev, [abstractId]: [...emails] }));
            setSelectedRevisors((prev) => ({ ...prev, [abstractId]: [...emails] }));
            // Update the abstract's revisor field in local state
            setAbstracts((prev) =>
              prev ? prev.map((a) => a.id === abstractId ? { ...a, revisor: emails } : a) : prev
            );
            setSavingRevisors((prev) => ({ ...prev, [abstractId]: false }));
        } catch (error) {
            setSavingRevisors((prev) => ({ ...prev, [abstractId]: false }));
            alert('Error al actualizar revisor');
        }
    };

  const handleAcceptAbstract = async (abstract) => {
    const type = acceptType[abstract.id];
    if (!type) return;

    const correspondingAuthor = abstract.authors?.find(a => a.correspondingAuthor);
    const authorName = correspondingAuthor
      ? `${correspondingAuthor.name} ${correspondingAuthor.lastName}`
      : '';
    const authorEmail = correspondingAuthor?.email || abstract.user_email;

    setAcceptingAbstract(prev => ({ ...prev, [abstract.id]: true }));
    try {
      await fetch(
        `https://nt6dwl1xpc.execute-api.us-west-1.amazonaws.com/produccion/revisors/abstracts/accept/${abstract.id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'user-token': localStorage.getItem('id_token'),
          },
          body: JSON.stringify({
            type,
            abstract_id: abstract.id,
            updated_at: abstract.updated_at,
            title: abstract.title,
            author_name: authorName,
            corresponding_author_email: authorEmail,
          }),
        },
      );
      setAbstracts(prev =>
        prev ? prev.map(a => a.id === abstract.id ? { ...a, accepted: type } : a) : prev,
      );
    } catch (error) {
      alert('Error sending acceptance email');
    } finally {
      setAcceptingAbstract(prev => ({ ...prev, [abstract.id]: false }));
    }
  };

  const handleSendCertificate = async (abstract) => {
    const participation = certificateType[abstract.id] || abstract.accepted || abstract.participation;
    if (!participation) {
      alert('Selecciona el tipo de participación antes de enviar el certificado');
      return;
    }

    setSendingCertificate(prev => ({ ...prev, [abstract.id]: true }));
    try {
      const response = await fetch(
        'https://nt6dwl1xpc.execute-api.us-west-1.amazonaws.com/produccion/admin/abstracts/certificate',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'user-token': localStorage.getItem('id_token'),
          },
          body: JSON.stringify({
            abstract_id: abstract.id,
            updated_at: abstract.updated_at,
            participation,
            title: abstract.title,
          }),
        },
      );
      if (!response.ok) throw new Error('Request failed');
      setAbstracts(prev =>
        prev ? prev.map(a => a.id === abstract.id ? { ...a, participation } : a) : prev,
      );
    } catch (error) {
      alert('Error al enviar el certificado');
    } finally {
      setSendingCertificate(prev => ({ ...prev, [abstract.id]: false }));
    }
  };

  const downloadCsv = () => {
    if (!abstracts || abstracts.length === 0) return;

    const esc = (val) => `"${String(val ?? '').replace(/"/g, '""')}"`;

    const headers = [
      'Title',
      'Category',
      'Status',
      'Updated At',
      'Email',
      'Authors',
      'Presenting Author Affiliation',
      'Corresponding Author Name',
      'Corresponding Author Email',
      'Corresponding Author Affiliation',
      'Revisors',
      'Requested Type',
      'Accepted',
    ];

    const csvRows = [headers.map(esc).join(',')];

    abstracts.forEach((abstract) => {
      const authorsStr = (abstract.authors || [])
        .map(a => `${a.name} ${a.lastName}${a.presentingAuthor ? ' (🎤)' : ''}${a.correspondingAuthor ? ' (✉)' : ''}`)
        .join('; ');

      const presenter = (abstract.authors || []).find(a => a.presentingAuthor) || (abstract.authors || [])[0];
      const affiliation = (presenter?.affiliations || []).join('; ');

      const corrAuthor = (abstract.authors || []).find(a => a.correspondingAuthor);
      const corrAuthorName = corrAuthor ? `${corrAuthor.name} ${corrAuthor.lastName}` : '';
      const corrAuthorEmail = corrAuthor?.email || '';
      const corrAuthorAffiliation = (corrAuthor?.affiliations || []).join('; ');

      const revisorsStr = Array.isArray(abstract.revisor)
        ? abstract.revisor.join('; ')
        : (abstract.revisor || '');

      const row = [
        abstract.title,
        abstract.category,
        abstract.status,
        abstract.updated_at,
        abstract.user_email,
        authorsStr,
        affiliation,
        corrAuthorName,
        corrAuthorEmail,
        corrAuthorAffiliation,
        revisorsStr,
        abstract.presentation_type,
        abstract.accepted,
      ].map(esc);

      csvRows.push(row.join(','));
    });

    const csvString = '\uFEFF' + csvRows.join('\n');
    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'abstracts.csv';
    link.click();
    URL.revokeObjectURL(url);
  };

  const deleteAbstract = (abstractId, updates_at) => {
    console.log('Deleting');
    setIsLoading(true);
    setLoadingMessage('Deleting abstracts');
    saveAbstractRequest({ abstract_id: abstractId, updated_at: updates_at }).then(() =>
      window.location.reload(),
    );
  };

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  const getScoreStats = (scores) => {
    if (!scores || !Array.isArray(scores) || scores.length === 0) {
      return { count: 0, mean: 0, hasScores: false };
    }
    const numericScores = scores.map(s => {
      if (typeof s === 'object' && s !== null) return Number(s.score || s.value || 0);
      return Number(s);
    }).filter(n => !isNaN(n));
    if (numericScores.length === 0) return { count: 0, mean: 0, hasScores: false };
    const sum = numericScores.reduce((acc, val) => acc + val, 0);
    return { count: numericScores.length, mean: sum / numericScores.length, hasScores: true };
  };

  const getFilteredAbstracts = (list) => {
    if (!list || !searchQuery.trim()) return list;
    const q = searchQuery.toLowerCase().trim();
    return list.filter((a) => {
      const revisorStr = Array.isArray(a.revisor) ? a.revisor.join(', ') : (a.revisor || '');
      return (a.title || '').toLowerCase().includes(q) ||
        (a.user_email || '').toLowerCase().includes(q) ||
        (a.code || '').toLowerCase().includes(q) ||
        (a.category || '').toLowerCase().includes(q) ||
        revisorStr.toLowerCase().includes(q);
    });
  };

  const getSortedAbstracts = (list) => {
    if (!list || !sortConfig.key) return list;
    const sorted = [...list].sort((a, b) => {
      let valA, valB;
      if (sortConfig.key === 'revisor_status') {
        valA = parseRevisors(a.revisor).length > 0 ? 1 : 0;
        valB = parseRevisors(b.revisor).length > 0 ? 1 : 0;
      } else if (sortConfig.key === 'score_mean') {
        valA = getScoreStats(a.score).mean;
        valB = getScoreStats(b.score).mean;
      } else {
        valA = (a[sortConfig.key] || '').toString().toLowerCase();
        valB = (b[sortConfig.key] || '').toString().toLowerCase();
      }
      if (valA < valB) return sortConfig.direction === 'asc' ? -1 : 1;
      if (valA > valB) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
    return sorted;
  };

  const sortedAbstracts = getSortedAbstracts(getFilteredAbstracts(abstracts));

  const SortIcon = ({ columnKey }) => {
    if (sortConfig.key !== columnKey) return <span style={{ opacity: 0.3, marginLeft: 4 }}>↕</span>;
    return <span style={{ marginLeft: 4 }}>{sortConfig.direction === 'asc' ? '↑' : '↓'}</span>;
  };

  SortIcon.propTypes = {
    columnKey: PropTypes.string.isRequired,
  };

  const getRevisorStatus = (abstractId) => {
    const selected = (selectedRevisors[abstractId] || []).slice().sort().join(',');
    const saved = (savedRevisors[abstractId] || []).slice().sort().join(',');
    if (savingRevisors[abstractId]) return 'saving';
    if (selected !== saved) return 'unsaved';
    return 'saved';
  };

  return (
    <div className="snn-user-home-main-wrapper">
      <SideMenuAdmin />
      <div className="snn-abstract-submission-main-grid-wrapper">
        <LoadingLayer isLoading={isLoading} action={loadingMessage} />

        <section className="snn-expand-grid-4">
          <h1 className="snn-user-home-main-content-header">Abstracts</h1>
          <button
            onClick={downloadCsv}
            disabled={!abstracts || abstracts.length === 0}
            style={{
              marginBottom: '16px',
              padding: '8px 16px',
              backgroundColor: '#0b6ef6',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: 600,
            }}
          >
            Download CSV <span className="material-symbols-outlined" style={{ verticalAlign: 'middle', marginLeft: 4 }}>download</span>
          </button>

          <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
            <button
              onClick={() => setViewMode('cards')}
              style={{
                padding: '8px 16px',
                backgroundColor: viewMode === 'cards' ? '#0b6ef6' : '#e0e0e0',
                color: viewMode === 'cards' ? '#fff' : '#333',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontWeight: 600,
              }}
            >
              <span className="material-symbols-outlined" style={{ verticalAlign: 'middle', marginRight: 4 }}>grid_view</span>
              Cards
            </button>
            <button
              onClick={() => setViewMode('table')}
              style={{
                padding: '8px 16px',
                backgroundColor: viewMode === 'table' ? '#0b6ef6' : '#e0e0e0',
                color: viewMode === 'table' ? '#fff' : '#333',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontWeight: 600,
              }}
            >
              <span className="material-symbols-outlined" style={{ verticalAlign: 'middle', marginRight: 4 }}>table_rows</span>
              Table
            </button>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
            <div style={{ position: 'relative', flex: 1, maxWidth: '400px' }}>
              <span className="material-symbols-outlined" style={{
                position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)',
                color: '#94a3b8', fontSize: '20px',
              }}>search</span>
              <input
                type="text"
                placeholder="Search by title, email, code, category or revisor..."
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                style={{
                  width: '100%', padding: '10px 12px 10px 36px', fontSize: '14px',
                  border: '1px solid #ddd', borderRadius: '6px', outline: 'none',
                  boxSizing: 'border-box',
                }}
              />
              {searchQuery && (
                <button
                  onClick={() => setSearchQuery('')}
                  style={{
                    position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)',
                    background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8',
                    fontSize: '18px', lineHeight: 1, padding: 0,
                  }}
                >×</button>
              )}
            </div>
            {abstracts && (
              <span style={{ fontSize: '13px', color: '#666', whiteSpace: 'nowrap' }}>
                {sortedAbstracts ? sortedAbstracts.length : 0} / {abstracts.length} abstracts
              </span>
            )}
          </div>

          {viewMode === 'table' && abstracts && (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
                <thead>
                  <tr style={{ backgroundColor: '#f5f5f5', textAlign: 'left' }}>

                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd', cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('title')}>
                      Title <SortIcon columnKey="title" />
                    </th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd', cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('category')}>
                      Category <SortIcon columnKey="category" />
                    </th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd', cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('status')}>
                      Status <SortIcon columnKey="status" />
                    </th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd' }}>Email</th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd' }}>Authors</th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd' }}>Affiliation</th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd' }}>Corr. Author Name</th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd' }}>Corr. Author Email</th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd' }}>Corr. Author Affiliation</th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd', cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('revisor_status')}>
                      Revisor <SortIcon columnKey="revisor_status" />
                    </th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd', cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('score_mean')}>
                      Score <SortIcon columnKey="score_mean" />
                    </th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd' }}>Certificate</th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd', cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('presentation_type')}>
                      Req. Type <SortIcon columnKey="presentation_type" />
                    </th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd' }}>Accept</th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd' }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedAbstracts.map((abstract) => (
                    <tr
                      key={abstract.id + abstract.title}
                      style={{ borderBottom: '1px solid #eee' }}
                    >
                      <td style={{ padding: '8px 12px', maxWidth: '250px' }}>
                        <Link to={`/abstracts/${abstract.id}`} style={{ color: '#0b6ef6', textDecoration: 'none' }}>
                          {abstract.title}
                        </Link>
                      </td>
                      <td style={{ padding: '8px 12px', whiteSpace: 'nowrap' }}>
                        <span
                          style={{
                            display: 'inline-block',
                            padding: '2px 8px',
                            borderRadius: '12px',
                            fontSize: '12px',
                            fontWeight: 600,
                            color: '#fff',
                            backgroundColor:
                              {
                                'Advanced materials and physics of nanostructures': '#6366f1',
                                Bionanotechnology: '#22c55e',
                                Nanophotonics: '#f59e0b',
                                'Physical-chemistry of nanomaterials and nanocatalysis': '#ef4444',
                                'Tech innovation in nanoscience': '#3b82f6',
                              }[abstract.category] || '#94a3b8',
                          }}
                        >
                          {abstract.category || 'N/A'}
                        </span>
                      </td>
                      <td style={{ padding: '8px 12px' }}>
                        <span
                          style={{
                            display: 'inline-block',
                            padding: '2px 8px',
                            borderRadius: '12px',
                            fontSize: '12px',
                            fontWeight: 600,
                            backgroundColor: abstract.status === 'Submitted' ? '#dcfce7' : '#fef3c7',
                            color: abstract.status === 'Submitted' ? '#166534' : '#92400e',
                          }}
                        >
                          {abstract.status}
                        </span>
                      </td>
                      <td style={{ padding: '8px 12px', fontSize: '13px' }}>
                        {abstract.user_email}
                      </td>
                      <td style={{ padding: '8px 12px' }}>
                        {abstract.authors && abstract.authors.length > 0 ? (
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                            {abstract.authors.map((author, i) => (
                              <div key={i} style={{ fontSize: '12px', lineHeight: 1.4 }}>
                                <span style={{ color: '#333' }}>
                                  {author.name} {author.lastName}
                                </span>
                                <span style={{ color: '#94a3b8', fontSize: '11px' }}> — {author.degree}</span>
                                {author.correspondingAuthor && (
                                  <span title="Corresponding author" style={{ marginLeft: '4px', fontSize: '11px' }}>✉</span>
                                )}
                                {author.presentingAuthor && (
                                  <span title="Presenting author" style={{ marginLeft: '2px', fontSize: '11px' }}>🎤</span>
                                )}
                              </div>
                            ))}
                          </div>
                        ) : (
                          <span style={{ color: '#94a3b8', fontSize: '12px' }}>No authors</span>
                        )}
                      </td>
                      {/* Presenting author affiliation */}
                      <td style={{ padding: '8px 12px', maxWidth: '200px' }}>
                        {(() => {
                          const presenter = abstract.authors?.find(a => a.presentingAuthor) || abstract.authors?.[0];
                          const affiliations = presenter?.affiliations;
                          if (!affiliations || affiliations.length === 0) {
                            return <span style={{ color: '#94a3b8', fontSize: '12px' }}>—</span>;
                          }
                          return (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                              {affiliations.map((aff, i) => (
                                <span key={i} style={{ fontSize: '12px', color: '#334155' }}>{aff}</span>
                              ))}
                            </div>
                          );
                        })()}
                      </td>
                      {/* Corresponding author name */}
                      <td style={{ padding: '8px 12px', fontSize: '13px', fontWeight: 600 }}>
                        {(() => {
                          const corr = abstract.authors?.find(a => a.correspondingAuthor);
                          return corr ? `${corr.name} ${corr.lastName}` : <span style={{ color: '#94a3b8', fontSize: '12px' }}>—</span>;
                        })()}
                      </td>
                      {/* Corresponding author email */}
                      <td style={{ padding: '8px 12px', fontSize: '13px' }}>
                        {(() => {
                          const corr = abstract.authors?.find(a => a.correspondingAuthor);
                          return corr?.email || <span style={{ color: '#94a3b8', fontSize: '12px' }}>—</span>;
                        })()}
                      </td>
                      {/* Corresponding author affiliation */}
                      <td style={{ padding: '8px 12px', maxWidth: '200px' }}>
                        {(() => {
                          const corr = abstract.authors?.find(a => a.correspondingAuthor);
                          const affiliations = corr?.affiliations;
                          if (!affiliations || affiliations.length === 0) {
                            return <span style={{ color: '#94a3b8', fontSize: '12px' }}>—</span>;
                          }
                          return (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                              {affiliations.map((aff, i) => (
                                <span key={i} style={{ fontSize: '12px', color: '#334155' }}>{aff}</span>
                              ))}
                            </div>
                          );
                        })()}
                      </td>
                      <td style={{ padding: '8px 12px' }}>
                        {/* Per-row status indicator */}
                        {(() => {
                          const status = getRevisorStatus(abstract.id);
                          if (status === 'saving') return (
                            <span style={{ fontSize: '11px', color: '#f59e0b', fontWeight: 600, display: 'block', marginBottom: '4px' }}>
                              ⏳ Saving...
                            </span>
                          );
                          if (status === 'unsaved') return (
                            <span style={{ fontSize: '11px', color: '#f59e0b', fontWeight: 600, display: 'block', marginBottom: '4px' }}>
                              ● Unsaved changes
                            </span>
                          );
                          if ((selectedRevisors[abstract.id] || []).length > 0) return (
                            <span style={{ fontSize: '11px', color: '#166534', fontWeight: 600, display: 'block', marginBottom: '4px' }}>
                              ✓ Saved
                            </span>
                          );
                          return null;
                        })()}
                        {/* Assigned revisors as editable chips */}
                        {(selectedRevisors[abstract.id] || []).length > 0 ? (
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginBottom: '6px' }}>
                            {(selectedRevisors[abstract.id] || []).map(email => (
                              <span key={email} style={{
                                display: 'inline-flex', alignItems: 'center', gap: '4px',
                                padding: '3px 8px', borderRadius: '12px', fontSize: '11px',
                                backgroundColor: '#e0e7ff', color: '#3730a3', fontWeight: 600,
                              }}>
                                {email}
                                <button
                                  onClick={() => handleRemoveRevisor(abstract.id, email)}
                                  style={{
                                    background: 'none', border: 'none', color: '#dc2626',
                                    cursor: 'pointer', padding: 0, fontSize: '14px', lineHeight: 1,
                                  }}
                                  title="Remove revisor"
                                >×</button>
                              </span>
                            ))}
                          </div>
                        ) : (
                          <span style={{ color: '#dc2626', fontWeight: 600, fontSize: '12px', display: 'block', marginBottom: '6px' }}>
                            ✗ Not assigned
                          </span>
                        )}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                          <select
                            value=""
                            onChange={e => handleAddRevisor(abstract.id, e.target.value)}
                            disabled={(selectedRevisors[abstract.id] || []).length >= 2}
                            style={{ padding: '4px', fontSize: '12px', borderRadius: '4px', border: '1px solid #ccc' }}
                          >
                            <option value="" disabled>
                              {(selectedRevisors[abstract.id] || []).length >= 2 ? 'Max 2' : 'Add revisor'}
                            </option>
                            {revisorsEmails
                              .filter(email => !(selectedRevisors[abstract.id] || []).includes(email))
                              .map(email => (
                                <option key={email} value={email}>{email}</option>
                              ))}
                          </select>
                          <button
                            onClick={() => updateRevisor(abstract.id, abstract.updated_at)}
                            disabled={savingRevisors[abstract.id] || getRevisorStatus(abstract.id) === 'saved'}
                            style={{
                              padding: '4px 8px',
                              fontSize: '12px',
                              backgroundColor: getRevisorStatus(abstract.id) === 'unsaved' ? '#f59e0b' : (getRevisorStatus(abstract.id) === 'saving' ? '#94a3b8' : '#22c55e'),
                              color: '#fff',
                              border: 'none',
                              borderRadius: '4px',
                              cursor: getRevisorStatus(abstract.id) === 'unsaved' ? 'pointer' : 'not-allowed',
                              opacity: getRevisorStatus(abstract.id) === 'saved' ? 0.5 : 1,
                            }}
                          >
                            {savingRevisors[abstract.id] ? '...' : (getRevisorStatus(abstract.id) === 'saved' ? '✓ Saved' : 'Save')}
                          </button>
                        </div>
                      </td>
                      <td style={{ padding: '8px 12px', textAlign: 'center' }}>
                        {(() => {
                          const stats = getScoreStats(abstract.score);
                          if (!stats.hasScores) {
                            return (
                              <span style={{
                                display: 'inline-block', padding: '2px 10px', borderRadius: '12px',
                                fontSize: '12px', fontWeight: 600,
                                backgroundColor: '#fef2f2', color: '#991b1b', border: '1px dashed #fca5a5',
                              }}>
                                No scores
                              </span>
                            );
                          }
                          return (
                            <div>
                              <div style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>
                                ({stats.count} {stats.count === 1 ? 'review' : 'reviews'})
                              </div>
                              <button
                                onClick={() => setScoreModalAbstract(abstract)}
                                style={{
                                  marginTop: '4px', padding: '2px 8px', fontSize: '11px',
                                  backgroundColor: '#0b6ef6', color: '#fff', border: 'none',
                                  borderRadius: '4px', cursor: 'pointer',
                                }}
                              >
                                View details
                              </button>
                            </div>
                          );
                        })()}
                      </td>
                      <td style={{ padding: '8px 12px', textAlign: 'center', minWidth: '160px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', alignItems: 'center' }}>
                          {abstract.participation ? (
                            <span style={{
                              display: 'inline-block', padding: '3px 10px', borderRadius: '12px',
                              fontSize: '12px', fontWeight: 700,
                              backgroundColor: '#dcfce7', color: '#166534',
                            }}>
                              ✓ Sent ({abstract.participation})
                            </span>
                          ) : (
                            <span style={{ fontSize: '11px', color: '#94a3b8' }}>Not sent yet</span>
                          )}
                          <select
                            value={certificateType[abstract.id] || ''}
                            onChange={e => setCertificateType(prev => ({ ...prev, [abstract.id]: e.target.value }))}
                            style={{ padding: '4px 6px', fontSize: '12px', borderRadius: '4px', border: '1px solid #ccc', width: '100%' }}
                          >
                            <option value="" disabled>
                              {abstract.participation ? 'Change…' : 'Select type…'}
                            </option>
                            <option value="oral">Oral</option>
                            <option value="poster">Poster</option>
                            <option value="attendee">Attendee</option>
                          </select>
                          <button
                            onClick={() => handleSendCertificate(abstract)}
                            disabled={!certificateType[abstract.id] || sendingCertificate[abstract.id]}
                            style={{
                              padding: '4px 10px', fontSize: '12px', borderRadius: '4px', border: 'none',
                              backgroundColor: !certificateType[abstract.id] ? '#e5e7eb' : abstract.participation ? '#f59e0b' : '#0b6ef6',
                              color: !certificateType[abstract.id] ? '#9ca3af' : '#fff',
                              cursor: !certificateType[abstract.id] ? 'not-allowed' : 'pointer',
                              width: '100%',
                            }}
                          >
                            {sendingCertificate[abstract.id] ? 'Sending…' : abstract.participation ? 'Resend' : 'Send'}
                          </button>
                        </div>
                      </td>
                      {/* Requested type column */}
                      <td style={{ padding: '8px 12px', textAlign: 'center' }}>
                        {abstract.presentation_type ? (
                          (() => {
                            const pt = abstract.presentation_type.toLowerCase();
                            const isOral = pt.includes('oral');
                            const isPoster = pt.includes('poster');
                            return (
                              <span style={{
                                display: 'inline-block', padding: '3px 10px', borderRadius: '12px',
                                fontSize: '12px', fontWeight: 700,
                                backgroundColor: isOral ? '#ede9fe' : isPoster ? '#fef9c3' : '#f1f5f9',
                                color: isOral ? '#5b21b6' : isPoster ? '#854d0e' : '#475569',
                              }}>
                                {isOral ? '🎤 Oral' : isPoster ? '🖼 Poster' : abstract.presentation_type}
                              </span>
                            );
                          })()
                        ) : (
                          <span style={{ color: '#94a3b8', fontSize: '12px' }}>—</span>
                        )}
                      </td>
                      {/* Accept column */}
                      <td style={{ padding: '8px 12px', textAlign: 'center', minWidth: '160px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', alignItems: 'center' }}>
                          {/* Current status badge */}
                          {abstract.accepted ? (
                            <span style={{
                              display: 'inline-block', padding: '3px 10px', borderRadius: '12px',
                              fontSize: '12px', fontWeight: 700,
                              backgroundColor:
                                abstract.accepted === 'oral' ? '#dbeafe' :
                                abstract.accepted === 'poster' ? '#dcfce7' : '#fef2f2',
                              color:
                                abstract.accepted === 'oral' ? '#1d4ed8' :
                                abstract.accepted === 'poster' ? '#166534' : '#991b1b',
                            }}>
                              {abstract.accepted === 'oral' ? '🎤 Oral' :
                               abstract.accepted === 'poster' ? '🖼 Poster' : '✗ Rejected'}
                            </span>
                          ) : (
                            <span style={{ fontSize: '11px', color: '#94a3b8' }}>Not sent yet</span>
                          )}
                          {/* Dropdown + button (always visible so admin can change/resend) */}
                          <select
                            value={acceptType[abstract.id] || ''}
                            onChange={e => setAcceptType(prev => ({ ...prev, [abstract.id]: e.target.value }))}
                            style={{ padding: '4px 6px', fontSize: '12px', borderRadius: '4px', border: '1px solid #ccc', width: '100%' }}
                          >
                            <option value="" disabled>
                              {abstract.accepted ? 'Change…' : 'Select type…'}
                            </option>
                            <option value="oral">Oral</option>
                            <option value="poster">Poster</option>
                            <option value="rejected">Rejected</option>
                          </select>
                          <button
                            onClick={() => handleAcceptAbstract(abstract)}
                            disabled={!acceptType[abstract.id] || acceptingAbstract[abstract.id]}
                            style={{
                              padding: '4px 10px', fontSize: '12px', borderRadius: '4px', border: 'none',
                              backgroundColor: !acceptType[abstract.id] ? '#e5e7eb' : abstract.accepted ? '#f59e0b' : '#0b6ef6',
                              color: !acceptType[abstract.id] ? '#9ca3af' : '#fff',
                              cursor: !acceptType[abstract.id] ? 'not-allowed' : 'pointer',
                              width: '100%',
                            }}
                          >
                            {acceptingAbstract[abstract.id] ? 'Sending…' : abstract.accepted ? 'Resend' : 'Send'}
                          </button>
                        </div>
                      </td>
                      <td style={{ padding: '8px 12px' }}>
                        <div style={{ display: 'flex', gap: '4px' }}>
                          <Link to={'/abstracts/edit/' + abstract.id} style={{ color: '#0b6ef6', fontSize: '13px' }}>
                            Edit
                          </Link>
                          <button
                            onClick={() => deleteAbstract(abstract.id, abstract.updated_at)}
                            style={{
                              background: 'none',
                              border: 'none',
                              color: '#dc2626',
                              cursor: 'pointer',
                              fontSize: '13px',
                              padding: 0,
                            }}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {viewMode === 'cards' && (
          <div>
            {sortedAbstracts &&
              sortedAbstracts.map((abstract) => (
                <Link key={abstract.id + abstract.title} to={`/abstracts/${abstract.id}`}>
                  <div
                    className={
                      'snn-abstract-registered-card' +
                      {
                        'Advanced materials and physics of nanostructures':
                          ' snn-user-home-abstract-advanced',
                        Bionanotechnology: ' snn-user-home-abstract-bio',
                        Nanophotonics: ' snn-user-home-nanophotonic',
                        'Physical-chemistry of nanomaterials and nanocatalysis':
                          ' snn-user-home-catalysis',
                        'Tech innovation in nanoscience': ' snn-user-home-innovation',
                      }[
                        abstract.category
                          ? abstract.category
                          : 'Advanced materials and physics of nanostructures'
                      ] +
                      (abstract.status === 'Submitted'
                        ? ' snn-abstract-registered-card-submitted'
                        : ' snn-abstract-registered-card-draft')
                    }
                  >
                    <p className="snn-user-home-main-content-small-text">{abstract.status}</p>
                    {abstract.code === 'undefined' ? null : (
                      <p className="snn-user-home-main-content-small-text">{abstract.code}</p>
                    )}
                    <div className="snn-abstract-registered-card-text">
                      <div className="snn-abstract-admin-details">
                        <p className="snn-user-home-main-content-large-semi">{abstract.title}</p>
                        <p>
                          Cognito username: <strong>{abstract.cognito_username}</strong>
                        </p>
                        <p>
                          User email: <strong>{abstract.user_email}</strong>
                        </p>
                        <p>
                          Updated at: <strong>{abstract.updated_at}</strong>
                        </p>
                          <p>
                              Revisor:
                              {(selectedRevisors[abstract.id] || []).length > 0
                                ? <strong> {(selectedRevisors[abstract.id] || []).join(', ')}</strong>
                                : <strong> Not revisor selected</strong>
                              }
                          </p>
                          <div
                              style={{ marginTop: '10px' }}
                              onMouseDown={e => e.stopPropagation()}
                              onClick={e => { e.preventDefault(); e.stopPropagation(); }}
                          >
                              <p style={{ margin: '0 0 6px 0' }}>
                                  <strong>Certificado: </strong>
                                  {abstract.participation
                                      ? <span style={{ color: '#166534' }}>✓ Enviado ({abstract.participation})</span>
                                      : <span style={{ color: '#94a3b8' }}>No enviado</span>
                                  }
                              </p>
                              <select
                                  value={certificateType[abstract.id] || ''}
                                  onChange={e => { e.stopPropagation(); setCertificateType(prev => ({ ...prev, [abstract.id]: e.target.value })); }}
                                  onClick={e => { e.preventDefault(); e.stopPropagation(); }}
                                  onMouseDown={e => e.stopPropagation()}
                              >
                                  <option value="" disabled>
                                      {abstract.participation ? 'Cambiar tipo…' : 'Selecciona tipo…'}
                                  </option>
                                  <option value="oral">Oral</option>
                                  <option value="poster">Poster</option>
                                  <option value="attendee">Attendee</option>
                              </select>
                              <button
                                  style={{
                                      marginLeft: '8px',
                                      padding: '4px 12px',
                                      fontSize: '12px',
                                      backgroundColor: !certificateType[abstract.id] ? '#e5e7eb' : abstract.participation ? '#f59e0b' : '#0b6ef6',
                                      color: !certificateType[abstract.id] ? '#9ca3af' : '#fff',
                                      border: 'none',
                                      borderRadius: '4px',
                                      cursor: !certificateType[abstract.id] ? 'not-allowed' : 'pointer',
                                  }}
                                  onClick={e => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      handleSendCertificate(abstract);
                                  }}
                                  disabled={!certificateType[abstract.id] || sendingCertificate[abstract.id]}
                              >
                                  {sendingCertificate[abstract.id]
                                      ? 'Enviando…'
                                      : abstract.participation ? 'Reenviar certificado' : 'Enviar certificado'}
                              </button>
                          </div>
                          <div style={{ marginTop: '10px' }} onMouseDown={e => e.stopPropagation()} onClick={e => { e.preventDefault(); e.stopPropagation(); }}>
                              {/* Per-row status indicator */}
                              {(() => {
                                const status = getRevisorStatus(abstract.id);
                                if (status === 'saving') return (
                                  <span style={{ fontSize: '11px', color: '#f59e0b', fontWeight: 600, display: 'block', marginBottom: '4px' }}>
                                    ⏳ Saving...
                                  </span>
                                );
                                if (status === 'unsaved') return (
                                  <span style={{ fontSize: '11px', color: '#f59e0b', fontWeight: 600, display: 'block', marginBottom: '4px' }}>
                                    ● Unsaved changes
                                  </span>
                                );
                                if ((selectedRevisors[abstract.id] || []).length > 0) return (
                                  <span style={{ fontSize: '11px', color: '#166534', fontWeight: 600, display: 'block', marginBottom: '4px' }}>
                                    ✓ Saved
                                  </span>
                                );
                                return null;
                              })()}
                              {/* Selected revisors chips */}
                              {(selectedRevisors[abstract.id] || []).length > 0 && (
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginBottom: '6px' }}>
                                  {(selectedRevisors[abstract.id] || []).map(email => (
                                    <span key={email} style={{
                                      display: 'inline-flex', alignItems: 'center', gap: '4px',
                                      padding: '2px 8px', borderRadius: '12px', fontSize: '12px',
                                      backgroundColor: '#e0e7ff', color: '#3730a3', fontWeight: 600,
                                    }}>
                                      {email}
                                      <button
                                        onClick={(e) => {
                                          e.preventDefault(); e.stopPropagation();
                                          handleRemoveRevisor(abstract.id, email);
                                        }}
                                        style={{
                                          background: 'none', border: 'none', color: '#dc2626',
                                          cursor: 'pointer', padding: 0, fontSize: '14px', lineHeight: 1,
                                        }}
                                        title="Remove revisor"
                                      >×</button>
                                    </span>
                                  ))}
                                </div>
                              )}
                              <select
                                  value=""
                                  onChange={e => { e.stopPropagation(); handleAddRevisor(abstract.id, e.target.value); }}
                                  onClick={e => { e.preventDefault(); e.stopPropagation(); }}
                                  onMouseDown={e => e.stopPropagation()}
                                  disabled={(selectedRevisors[abstract.id] || []).length >= 2}
                              >
                                  <option value="" disabled>
                                    {(selectedRevisors[abstract.id] || []).length >= 2 ? 'Max 2 revisors' : 'Add revisor'}
                                  </option>
                                  {revisorsEmails
                                    .filter(email => !(selectedRevisors[abstract.id] || []).includes(email))
                                    .map(email => (
                                      <option key={email} value={email}>{email}</option>
                                  ))}
                              </select>
                              <button
                                  style={{
                                    marginLeft: '8px',
                                    padding: '4px 12px',
                                    fontSize: '12px',
                                    backgroundColor: getRevisorStatus(abstract.id) === 'unsaved' ? '#f59e0b' : (savingRevisors[abstract.id] ? '#94a3b8' : '#22c55e'),
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: getRevisorStatus(abstract.id) === 'unsaved' ? 'pointer' : 'not-allowed',
                                    opacity: getRevisorStatus(abstract.id) === 'saved' ? 0.5 : 1,
                                  }}
                                  onClick={e => {
                                      e.preventDefault();
                                      updateRevisor(abstract.id, abstract.updated_at);
                                  }}
                                  disabled={savingRevisors[abstract.id] || getRevisorStatus(abstract.id) === 'saved'}
                              >
                                  {savingRevisors[abstract.id] ? '...' : (getRevisorStatus(abstract.id) === 'saved' ? '✓ Saved' : 'Save')}
                              </button>
                          </div>
                      </div>
                      {abstract.category ? (
                        <img
                          src={TopicsList.filter((t) => t.name === abstract.category)[0].src_bg}
                        />
                      ) : null}
                    </div>
                    <div className="snn-abstract-registered-card-buttons-wrapper">
                      <Link to={'/abstracts/edit/' + abstract.id}>
                        <div className="snn-abstract-registered-card-button">
                          Edit <span className="material-symbols-outlined">edit</span>
                        </div>
                      </Link>
                      <div
                        onClick={(event) => {
                          event.preventDefault();
                          deleteAbstract(abstract.id, abstract.updated_at);
                        }}
                        className="snn-abstract-registered-card-button snn-abstract-registered-card-button-delete"
                      >
                        Delete <span className="material-symbols-outlined">close</span>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
          </div>
          )}

          {/* Score Details Modal */}
          {scoreModalAbstract && (
            <div
              style={{
                position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
                alignItems: 'center', justifyContent: 'center', zIndex: 1000,
              }}
              onClick={() => setScoreModalAbstract(null)}
            >
              <div
                style={{
                  backgroundColor: '#fff', borderRadius: '12px', padding: '24px',
                  maxWidth: '600px', width: '90%', maxHeight: '80vh', overflowY: 'auto',
                  boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
                }}
                onClick={e => e.stopPropagation()}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
                  <div>
                    <h2 style={{ margin: 0, fontSize: '18px', color: '#222' }}>Score Details</h2>
                    <p style={{ margin: '4px 0 0', fontSize: '13px', color: '#666' }}>
                      {scoreModalAbstract.title}
                    </p>
                  </div>
                  <button
                    onClick={() => setScoreModalAbstract(null)}
                    style={{
                      background: 'none', border: 'none', fontSize: '22px',
                      cursor: 'pointer', color: '#666', padding: '0 4px', lineHeight: 1,
                    }}
                  >×</button>
                </div>

                {/* Mean score summary */}
                {(() => {
                  const stats = getScoreStats(scoreModalAbstract.score);
                  return (
                    <div style={{
                      display: 'flex', alignItems: 'center', gap: '12px',
                      padding: '12px 16px', backgroundColor: '#f8fafc',
                      borderRadius: '8px', marginBottom: '16px',
                    }}>
                      <span style={{
                        fontSize: '28px', fontWeight: 700,
                        color: stats.mean >= 3 ? '#166534' : stats.mean >= 2 ? '#92400e' : '#991b1b',
                      }}>
                        {stats.mean.toFixed(1)}
                      </span>
                      <div>
                        <div style={{ fontSize: '13px', fontWeight: 600, color: '#333' }}>
                          Average Score
                        </div>
                        <div style={{ fontSize: '12px', color: '#666' }}>
                          {stats.count} {stats.count === 1 ? 'review' : 'reviews'}
                        </div>
                      </div>
                    </div>
                  );
                })()}

                {/* Individual reviews */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  {(scoreModalAbstract.score || []).map((entry, index) => {
                    const scoreValue = typeof entry === 'object' ? (entry.score || entry.value || 0) : entry;
                    const email = typeof entry === 'object' ? (entry.email || 'Unknown') : 'Unknown';
                    const message = typeof entry === 'object' ? (entry.message || '') : '';
                    const comments = typeof entry === 'object' ? (entry.comments || '') : '';

                    return (
                      <div
                        key={index}
                        style={{
                          border: '1px solid #e5e7eb', borderRadius: '8px',
                          padding: '14px 16px', backgroundColor: '#fff',
                        }}
                      >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span style={{
                              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                              width: '28px', height: '28px', borderRadius: '50%', fontSize: '13px', fontWeight: 700,
                              backgroundColor: Number(scoreValue) >= 3 ? '#dcfce7' : Number(scoreValue) >= 2 ? '#fef3c7' : '#fef2f2',
                              color: Number(scoreValue) >= 3 ? '#166534' : Number(scoreValue) >= 2 ? '#92400e' : '#991b1b',
                            }}>
                              {Number(scoreValue)}
                            </span>
                            <span style={{ fontSize: '13px', fontWeight: 600, color: '#333' }}>
                              {message}
                            </span>
                          </div>
                        </div>

                        <div style={{ fontSize: '12px', color: '#0b6ef6', marginBottom: comments ? '8px' : 0 }}>
                          <span className="material-symbols-outlined" style={{ fontSize: '14px', verticalAlign: 'middle', marginRight: '4px' }}>
                            person
                          </span>
                          {email}
                        </div>

                        {comments && (
                          <div style={{
                            fontSize: '13px', color: '#555', lineHeight: 1.5,
                            padding: '10px 12px', backgroundColor: '#f9fafb',
                            borderRadius: '6px', borderLeft: '3px solid #0b6ef6',
                          }}>
                            {comments}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>

                <button
                  onClick={() => setScoreModalAbstract(null)}
                  style={{
                    marginTop: '20px', width: '100%', padding: '10px',
                    backgroundColor: '#0b6ef6', color: '#fff', border: 'none',
                    borderRadius: '6px', cursor: 'pointer', fontWeight: 600, fontSize: '14px',
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          )}
        </section>
      </div>
    </div>
  );
};
